module.exports = ".mar {\n    margin-right: 8px;\n}"